import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
        Dialog,
        DialogBody,
        DialogContent,
        DialogHeader,
        DialogTitle,
    } from '@/components/ui/dialog';
    import { computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import type { OnboardingStep as OnboardingStepType } from '@/types';
    import OnboardingAssistant from './OnboardingAssistant.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingAssistantModal',
  props: {
    onboardingSteps: {},
    companyId: {},
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const { t } = useI18n();

    const props = __props;

    const emit = __emit;

    const open = computed({
        get: () => props.modelValue ?? false,
        set: (value) => emit('update:modelValue', value),
    });

    const handleCompleted = (incompleteSteps: number) => {
        if (incompleteSteps > 0) {
            open.value = false;
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: open.value,
    "onUpdate:open": _cache[2] || (_cache[2] = (value) => (open.value = value))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "flex flex-col sm:min-h-[700px] sm:max-w-2xl" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('onboarding.assistant.title')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogBody), { class: "flex flex-col" }, {
            default: _withCtx(() => [
              _createVNode(OnboardingAssistant, {
                ref: "assistant",
                "onboarding-steps": _ctx.onboardingSteps,
                "company-id": _ctx.companyId,
                modelValue: open.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event)),
                onCompleted: handleCompleted,
                onClose: _cache[1] || (_cache[1] = ($event: any) => (open.value = false))
              }, null, 8, ["onboarding-steps", "company-id", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})